import { useState, useEffect } from 'react';

const useIntersection = (element: React.RefObject<HTMLDivElement>): boolean => {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      {
        root: document.getElementById('scroll_view'),
        rootMargin: '0px',
        threshold: 1,
      },
    );

    element.current && observer.observe(element.current);

    return () => observer.unobserve(element.current);
  }, []);

  return isVisible;
};

export { useIntersection };
